import React from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import { useScreenDimensions } from "../_layout";
import { useModalKeyboardShortcuts } from "../platform/guards/modalKeyboardShortcuts";

const TypedConfirmationModal = ({
  isVisible,
  onClose,
  title,
  description,
  instruction,
  placeholder,
  value,
  onChangeText,
  onConfirm,
  isConfirmEnabled,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  maxLength = 120,
}) => {
  const { screenSize } = useScreenDimensions();

  const handleConfirm = () => {
    if (!isConfirmEnabled) return;
    onConfirm?.();
  };

  useModalKeyboardShortcuts({
    isVisible,
    onConfirm: handleConfirm,
    onCancel: onClose,
    isConfirmEnabled,
  });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={styles.modalContainer}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                width: screenSize === "small" ? 300 : 400,
                maxWidth: screenSize === "small" ? 300 : 400,
              },
            ]}
          >
            <Text style={[Fonts.bold18Centered, { marginBottom: 12 }]}>
              {title}
            </Text>

            {!!description && <Text style={styles.description}>{description}</Text>}
            {!!instruction && <Text style={styles.instruction}>{instruction}</Text>}

            <TextInput
              style={styles.input}
              value={value}
              onChangeText={onChangeText}
              onSubmitEditing={handleConfirm}
              placeholder={placeholder}
              placeholderTextColor={Colors.grayColor}
              autoCapitalize="none"
              autoCorrect={false}
              maxLength={maxLength}
            />

            <View style={styles.actions}>
              <TouchableOpacity onPress={onClose}>
                <View style={styles.cancelButton}>
                  <Text style={styles.cancelButtonText}>{cancelLabel}</Text>
                </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={handleConfirm} disabled={!isConfirmEnabled}>
                <View
                  style={[
                    styles.confirmButton,
                    !isConfirmEnabled && styles.confirmButtonDisabled,
                  ]}
                >
                  <Text style={styles.confirmButtonText}>{confirmLabel}</Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    position: "absolute",
  },
  modalView: {
    alignSelf: "center",
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    paddingHorizontal: 24,
    paddingVertical: 22,
  },
  description: {
    color: Colors.blackColor,
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 20,
  },
  instruction: {
    color: Colors.grayColor,
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 18,
    fontSize: 12,
  },
  input: {
    borderWidth: 1,
    borderColor: Colors.borderColor,
    borderRadius: 12,
    paddingHorizontal: 12,
    height: 40,
    outlineStyle: "none",
    color: Colors.blackColor,
  },
  actions: {
    ...GlobalStyles.HStack,
    justifyContent: "space-around",
    marginTop: 18,
  },
  cancelButton: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.redColor,
    width: 90,
    height: 35,
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButtonText: {
    color: Colors.redColor,
  },
  confirmButton: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.redColor,
    backgroundColor: Colors.redColor,
    width: 90,
    height: 35,
    alignItems: "center",
    justifyContent: "center",
  },
  confirmButtonDisabled: {
    opacity: 0.45,
  },
  confirmButtonText: {
    color: Colors.whiteColor,
  },
});

export default TypedConfirmationModal;
